var map = {
	"./arrow-left.svg": "857e",
	"./arrow-right-black.svg": "80ce",
	"./arrow-right.svg": "50c3",
	"./calendar.svg": "1a34",
	"./category.svg": "7fad",
	"./clear.svg": "1a7d",
	"./clinic-hover.svg": "67cc",
	"./clinic.svg": "f356",
	"./danger-square.svg": "8384",
	"./delete-hover.svg": "f022",
	"./delete.svg": "d739",
	"./details-hover.svg": "42df",
	"./details.svg": "af76",
	"./document-hover.svg": "28fc",
	"./document.svg": "3a30",
	"./download.svg": "6369",
	"./drop-down.svg": "90a8",
	"./edit-hover.svg": "b1f5",
	"./edit.svg": "6582",
	"./file-upload.svg": "1a18",
	"./message-hover.svg": "083a",
	"./message.svg": "e36a",
	"./password-blue.svg": "a798",
	"./password-gray.svg": "fb9b",
	"./password.svg": "6005",
	"./plus.svg": "8a37",
	"./profile.svg": "b855",
	"./search.svg": "51f2",
	"./success-square.svg": "921f",
	"./time-circle-hover.svg": "fc13",
	"./time-circle.svg": "c3fc",
	"./users-hover.svg": "8826",
	"./users.svg": "c802",
	"./warning-square.svg": "fdd8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";